module.exports = __webpack_public_path__ + "static/media/Waste-scaled.75b307a7.jpg";